import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import translationDE from "./locales/de.json"
import translationEN from "./locales/en.json"
import translationES from "./locales/es.json"
import translationFR from "./locales/fr.json"
import translationIT from "./locales/it.json"
import translationNL from "./locales/nl.json"
import translationPT from "./locales/pt.json"
import translationRU from "./locales/ru.json"
import translationZH from "./locales/zh-cn.json"

const resources = {
  en: {
    translation: translationEN
  },
  ru: {
    translation: translationRU
  },
  es: {
    translation: translationES
  },
  de: {
    translation: translationDE
  },
  fr: {
    translation: translationFR
  },
  it: {
    translation: translationIT
  },
  nl: {
    translation: translationNL
  },
  zh: {
    translation: translationZH
  },
  pt: {
    translation: translationPT
  }
}

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  //.use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  //.use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: resources,
    supportedLngs: ["en", "ru", "es", "de", "fr", "it", "nl", "zh", "pt"],
    fallbackLng: "en",
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      // Keys double as the natural-language source string, so interpolation can't use the
      // default {{var}} - that would show up literally in untranslated English text. _var_
      // reads as plain text until i18next substitutes it.
      prefix: "_",
      suffix: "_"
    },

    detection: {
      caches: ["localStorage"]
    }
  })

export default i18n
